// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"afa6fb5c","143":"afcf8962","424":"e53a3d81","494":"1d46b09f","533":"d1e3c96e","651":"bb6deebc","690":"99af3731","852":"c374bc88","940":"bbcefca9"}[chunkId] + ".chunk.js";
};